export interface IFieldSelector<TModel, TField> {
  (model: TModel): TField;
}

export interface IComparable<TModel> {
  (a: TModel, b: TModel): number;
}

export function stringSort<T>(selector: IFieldSelector<T, string>): IComparable<T> {
  return (a: T, b: T): number => {
    const aField = selector(a)!.toLowerCase();
    const bField = selector(b)!.toLowerCase();

    if (aField < bField) {
      return -1;
    } else if (aField > bField) {
      return 1;
    }
    return 0;
  };
}
